import React from 'react'
import Nav from '../components/Nav/Nav'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import TabTitle from '../components/TabTitle'
import AboutMe from '../components/AboutMe/AboutMe'
import Projects from '../Projects/Projects'
// import ToDo from '../Projects/ToDo'
import CaliHousePrice from '../Projects/CaliHousePrice'
import ArticleCategorisation from '../Projects/ArticleCategorisation'


const Home = () => {
  TabTitle('Home')

  return (
    <>
      <Nav />
      <Header />      
      <AboutMe />
      <br />
      <h3 >Recent Work</h3>
      {/* <ToDo /> */}
      <ArticleCategorisation />
      <CaliHousePrice />
      <Projects />
      <Footer />
    </>
  )
}

export default Home